import { appState } from "config/store";
import { User } from "firebase/auth";

export const autoRefreshToken = async (user: User): Promise<void> => {
  appState.accessToken.set(await user.getIdToken(true));
  setTimeout(async () => {
    autoRefreshToken(user);
  }, 3300000);
};
